import { Model } from "../base/Model";
export class OrderModel extends Model {
    constructor(data, events) {
        var _a, _b;
        super(data, events);
        this.customer = (_a = data === null || data === void 0 ? void 0 : data.customer) !== null && _a !== void 0 ? _a : { payment: '', address: '', email: '', phone: '' };
        this.formErrors = (_b = data === null || data === void 0 ? void 0 : data.formErrors) !== null && _b !== void 0 ? _b : {};
    }
    getCustomerData() {
        return Object.assign({}, this.customer);
    }
    setCustomerData(customerData, step = 'shipping') {
        this.customer = Object.assign(Object.assign({}, this.customer), customerData);
        this.emitChanges('order:customer:updated', { customer: this.getCustomerData() });
        this.validateCustomerData(step);
    }
    validateCustomerData(step) {
        const errors = {};
        if (step === 'shipping') {
            if (!this.customer.payment) {
                errors.payment = 'Необходимо выбрать способ оплаты';
            }
            if (!this.customer.address) {
                errors.address = 'Необходимо указать адрес';
            }
        }
        if (step === 'contacts') {
            if (!this.customer.email) {
                errors.email = 'Необходимо указать email';
            }
            if (!this.customer.phone) {
                errors.phone = 'Необходимо указать телефон';
            }
        }
        this.formErrors = errors;
        this.emitChanges('formErrors:change', this.formErrors);
        return Object.keys(errors).length === 0;
    }
    clearCustomerData() {
        this.customer = { payment: '', address: '', email: '', phone: '' };
        this.formErrors = {};
        this.emitChanges('order:customer:cleared', {});
    }
    getOrderData(items, total) {
        const order = Object.assign(Object.assign({}, this.customer), { items: [...items], total: total });
        this.emitChanges('order:data:ready', { order });
        return order;
    }
}
